import type { TemplateData } from '../template-engine'

interface MyTemplateData extends TemplateData {
  origin: string
  iframeVersion: string
}

interface ReadyIndicatorParams {
  origin: string
  iframeVersion: string
}

export function buildReadyIndicatorData(input: ReadyIndicatorParams): MyTemplateData {
  return {
    origin: input.origin,
    iframeVersion: input.iframeVersion
  }
}
